import { useEffect, useState } from "react";

import { useAuthConfig } from "../lib/auth";
import { nmsTokenValid, redirectToNmsLogin } from "../lib/nmsAuth";


// Re-check cadence for tokens that expire while the tab stays open.
const RECHECK_INTERVAL_MS = 60_000;

// Renders children only when the NMS dashboard token in shared localStorage
// is present and unexpired; otherwise hands the user to the dashboard login.
// Inert unless the backend config says nms_auth (unset locally, so local dev
// never sees it). Sits inside AuthGate, which resolves the config query.
export default function NmsAuthGate({ children }: { children: React.ReactNode }) {
  const cfg = useAuthConfig();
  const enabled = cfg.data?.nms_auth ?? false;
  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    const check = () => {
      if (nmsTokenValid()) {
        setValid(true);
      } else {
        setValid(false);
        redirectToNmsLogin();
      }
    };

    check();
    const intervalId = window.setInterval(check, RECHECK_INTERVAL_MS);
    window.addEventListener("focus", check);
    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", check);
    };
  }, [enabled]);

  if (!enabled) return <>{children}</>;
  if (!valid) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-500">Redirecting to sign-in…</p>
      </main>
    );
  }
  return <>{children}</>;
}
